/**
 * ContractSlice Extra Reducers
 * 
 * Handles async actions from RTK Query endpoints.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { ContractSliceState } from './state';
import { contractEndpoints } from '../endpoints/contractEndpoints';
import { feeScheduleEndpoints } from '../endpoints/feeScheduleEndpoints';

/**
 * Builds extra reducers for contract API endpoint matchers.
 */
export function buildContractExtraReducers(builder: ActionReducerMapBuilder<ContractSliceState>) {
  builder
    .addMatcher(
      contractEndpoints.endpoints.getContract.matchFulfilled,
      (state, action) => {
        state.currentContract = action.payload;
        state.isDirty = false;
        state.isEditing = false;
      }
    )
    .addMatcher(
      feeScheduleEndpoints.endpoints.getFeeSchedule.matchFulfilled,
      (state, action) => {
        state.currentFeeSchedule = action.payload;
        state.isDirty = false;
        state.isEditing = false;
      }
    );
}
